<cyborg-error-message class="error" *ngIf="error$ | async; else results">
  <strong>HUNTER has encountered an error.</strong> Please try again or contact
  <a routerLink="/customer-support">support</a>.
</cyborg-error-message>

<ng-template #results>
  <cyborg-section *ngIf="collections$ | async as collectionData; else loading">
    <div
      *ngIf="collectionData.emergingThreats as emergingThreats"
      id="emerging-threats"
    >
      <cyborg-collection
        *ngFor="let collection of emergingThreats"
        [data]="collection"
        [highlighting]="false"
      >
      </cyborg-collection>
    </div>
  </cyborg-section>
</ng-template>

<ng-template #loading>
  <div class="loading">
    <kendo-loader type="pulsing" themeColor="primary" size="large">
    </kendo-loader>
  </div>
</ng-template>
